export * from './job-positions-of-static-occupations';
export * from './top-localities';
export * from './front-view-impression-with-search-bar';
